module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "phone",
    attrs: {
      "href": ("tel:" + _vm.value)
    }
  }, [_vm._v("+" + _vm._s(_vm.country) + " (" + _vm._s(_vm.code) + ") "), _c('span', [_vm._v(_vm._s(_vm.number))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80a3f3a4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ext/Phone.vue
// module id = ac71608871c3e3a78963
// module chunks = 0